export default __webpack_public_path__ + "static/media/flag-denmark.2b0ed1e9.svg";